import SSSlide from './00-slideshare_slide'

function SSDocumentSlide(config){
  SSSlide.call(this, config);
  this.PADDING = 5;
}

SSDocumentSlide.prototype = new SSSlide();

SSDocumentSlide.prototype.wrapperOffset = function(){
  if (!this.config.show_image_player) {
    return this.currentViewMode.wrapperHeight + this.PADDING * 2;
  }
};

SSDocumentSlide.prototype.empty = function(){
  if (!this.config.show_image_player) {
    this.currentViewMode.wrapper.empty();
  }
};

SSDocumentSlide.prototype.displayLoading = function(){
  if (!this.config.show_image_player) {
    this.empty();
    $('<div/>').addClass('jsplSlideLoading').css({
      width : this.currentViewMode.width,
      height : this.currentViewMode.height - 10
    }).html('Loading...').appendTo(this.currentViewMode.wrapper);
  }
};

// only container size. content should scale to fit
SSDocumentSlide.prototype.setDimensions = function(dimensions){
  var viewWidth = dimensions.parentWidth;
  var viewHeight = dimensions.parentHeight - (this.PADDING*2);
  var viewAspect = viewWidth/viewHeight;

  var origwidth, origheight, contentAspect;

  if (this.contentWidth === undefined || this.contentHeight === undefined){
    // size is not available. Failing to height and width of container
    origwidth = viewWidth;
    origheight = viewWidth * 1.33;
    contentAspect = origwidth/origheight;
  } else {
    origwidth = this.contentWidth;
    origheight = this.contentHeight;
    contentAspect = origwidth/origheight;
  }

  var scale, contentScale, fontscale, width, height;
  var top, left;

  //perform width based manipulations
  contentScale = viewWidth/origwidth;
  fontscale = contentScale*16;
  width = viewWidth;
  scale = viewAspect/contentAspect;
  top = this.PADDING;
  height = scale * viewHeight;

  width = parseInt(width, 10);
  height = parseInt(height, 10);


  if (this.config.show_image_player) {
    this.currentViewMode.wrapper.addClass('jsplSlideWrapper ' + this.currentViewMode.bgColor);
  } else {
    this.currentViewMode.container.css({
      width: width,
      height: height,
      padding : this.PADDING + 'px 0'
    });

    this.currentViewMode.wrapper.addClass('jsplSlideWrapper ' + this.currentViewMode.bgColor).css({
      width: width,
      height: height
    });
  }

  this.currentViewMode.wrapperWidth = width;
  this.currentViewMode.wrapperHeight = height;
  this.currentViewMode.top = top;
  this.currentViewMode.left = 0;
  this.currentViewMode.contentScale = contentScale;
  this.currentViewMode.fontscale = fontscale;
  this.currentViewMode.width = width;
  this.currentViewMode.height = height;
};

SSDocumentSlide.prototype.hide = function(){
  if (this.config.show_image_player) {
    this.$slide.hide();
  } else {
    if (!this.currentViewMode.rendered){
      return;
    }
    this.empty();
    this.currentViewMode.wrapper.addClass('hide');
    delete(this.currentViewMode.contentElement);
    delete(this.currentViewMode.imageElement);
    this.currentViewMode.rendered = false;
  }
};

SSDocumentSlide.prototype.show = function(force){
  if (this.currentViewMode.rendered && !force){
    return;
  }
  this.currentViewMode.rendered = true;
  this.load();
};

SSDocumentSlide.prototype.play = function(){
  $.slideshareEventManager.trigger('slidechanged', {index : this.index});
  if (!this.config.show_image_player) {
    this.show();
  }
};

SSDocumentSlide.prototype.setContainer = function(config){
  var mode = config.mode;
  if (this.viewModes[mode] === undefined){
    if (this.config.show_image_player) {
      this.viewModes[mode] = {
        'rendered' : false,
        'bgColor' : config.bgColor || 'jsplBgColorBigfoot',
        'container' : config.container,
        'wrapper' : $('<div/>')
      };
    } else {
      this.viewModes[mode] = {
        'rendered' : false,
        'bgColor' : config.bgColor || 'jsplBgColorBigfoot',
        'container' : config.container,
        'wrapper' : $('<div/>').appendTo(config.container)
      };
    }

    this.viewModes[mode].container.css({
      position : 'relative'
    });
  }

  this.currentViewMode = this.viewModes[mode];
  this.currentViewMode.wrapper.removeClass('hide');
  this.currentMode = config.mode;
};

export default SSDocumentSlide